import styled, { css } from "styled-components/macro";
import tw from "twin.macro";
import { backDropFilter } from "../../../styles/style-guide";

const keyFrames = css`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Container = styled.div<{ fadeOut: boolean }>`
  ${keyFrames};
  ${tw`fixed left-0 top-0 h-full w-full flex items-center justify-center`};
  z-index: 999;
  backdrop-filter: ${backDropFilter};
  transition: opacity 0.6s ease;

  div {
    border: 2px solid transparent;
    position: absolute;
    border-radius: 50%;
    opacity: 60%;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    animation: spin 1s linear infinite;
  }

  div:nth-child(1) {
    ${tw`h-16 w-16 border-primaryClr`}
  }

  div:nth-child(2) {
    ${tw`h-12 w-12 border-blueClr`};
    animation-duration: 1.2s;
  }

  div:nth-child(3) {
    ${tw`h-8 w-8 border-orangeClr`}
  }

  ${({ fadeOut }) => fadeOut && "opacity:0;"}
`;
